import {
  DATA_DOWNLOADS_PATH,
  RESERVES_DEFINITION_PATH,
  ROOT_PATH,
  SETTINGS_PATH,
} from '../../../utils/constants';
import { Link, useLocation } from 'react-router-dom';

import Button from '@mui/material/Button';
import { ButtonList } from '../ButtonList';
import CloseIcon from '@mui/icons-material/Close';
import FullLogo from '../../../../assets/images/FullLogo.svg';
import React from 'react';
import { ShinyLink } from '../../Shiny';
import { SignOutButton } from '../SignOutButton';
import { useCurrentUser } from '../../../contexts/CurrentUserContext';
import { useLinks } from '../hooks/useLinks';
import { useMobileTrayStyles } from './MobileTray.style';

const SPACER = 'SPACER';

export const MobileTray = ({ onButtonClick, onCloseTray }) => {
  const classes = useMobileTrayStyles();
  const location = useLocation();
  const links = useLinks();
  const { isUserEntitled } = useCurrentUser();

  const path = location.pathname;

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Link to={ROOT_PATH}>
          <img id="logo" src={FullLogo} alt="Welligence-Logo" width={'172px'} height={'45px'} />
        </Link>
        <Button onClick={onCloseTray} color="inherit" underline="none" className={classes.link}>
          <CloseIcon />
        </Button>
      </div>
      <div className={classes.content}>
        {[
          ...links,
          SPACER,
          {
            title: 'SETTINGS',
            link: SETTINGS_PATH,
          },
          {
            title: 'HELP',
            link: RESERVES_DEFINITION_PATH,
          },
        ].map((link, i) =>
          link === SPACER ? (
            <div key="spacer" style={{ flexGrow: 1 }} />
          ) : link.type === 'menu' ? (
            <ButtonList key={`${i}-${link.title}`} link={link} onButtonClick={onButtonClick} />
          ) : link.type === 'shiny' ? (
            <ShinyLink
              key={`${i}-${link.title}`}
              link={link}
              styles={{ link: classes.link }}
              disabled={!isUserEntitled(DATA_DOWNLOADS_PATH)}
              onClickCallback={onButtonClick}
            />
          ) : link.type === 'href' ? (
            <Button
              key={`${i}-${link.title}`}
              color="inherit"
              underline="none"
              className={classes.link}
              onClick={() => window.open(link.link, '_blank')}
            >
              {link.title}
            </Button>
          ) : (
            <Button
              key={`${i}-${link.title}`}
              component={Link}
              onClick={onButtonClick}
              to={`${link.link}`}
              color="inherit"
              underline="none"
              disabled={!isUserEntitled(link.link)}
              className={path.indexOf(link.link) !== -1 ? classes.selectedLink : classes.link}
            >
              {link.title}
            </Button>
          ),
        )}
        <SignOutButton onClick={onButtonClick} />
      </div>
    </div>
  );
};
